import React, { useState, useEffect } from "react";
import { Col, Container, Row, Form, Tab, Nav, Table } from "react-bootstrap";
import { AXIOS, api_key } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { updatePair } from "../../store/selectedPair";
import { IoMdArrowDropdown } from "react-icons/io";
import TradingViewWidget, { Themes } from "react-tradingview-widget";
import bitcoin from "../../assets/images/spot/bitcoin.png";
import btc from "../../assets/images/spot/btc.jpg";

import OrderBook from "./newcomponents/orderBook";
import TradeOrderBook from "./newcomponents/tradeOrderBook";
import Tabss from "./tabss";
import TradeTable from "./newcomponents/tradeTable";
import AssetTable from "./newcomponents/assetTable";
import "./spot_styles/spotupper.css";
import { AiOutlineStar } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
// const [input, setInput] = useState("");

export default function SpotSuper() {

  // const fetchData = (value) => {
  //   const searchResults = data.filter((item: any) =>
  //     item.name.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setSearchResults(searchResults);

  // };
  
  // const handleChange = (value: any) => {
  //   setInput(value)
  //   fetchData(value)
  // }
  // const handleFocus = async () => {
  //   try {
  //     const response = await AXIOS.post('/getCoinList', {
  //       api_key: api_key,

  //     });
      // console.log('response', response.data.data)
      // setSearchResults(response.data.data);

      // setData(response.data.data);
      // if (input.length > 0) {
      //   fetchData(input)
      // }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const handleBlur = () => {
  //   setTimeout(() => {

  //     setSearchResults([]);
  //   }, 300);

  // };

  const dropTable = [
    {
      pair: {
        icon: AiOutlineStar,
        text: "SULLI / USDT",
      },
      lastPrice: "0.543218 / $ 0.54",
      vol24: 5.61,
    },
    {
      pair: {
        icon: AiOutlineStar,
        text: "SULLI / USDT",
      },
      lastPrice: "0.543218 / $ 0.54",
      vol24: 5.61,
    },
    {
      pair: {
        icon: AiOutlineStar,
        text: "SULLI / USDT",
      },
      lastPrice: "0.543218 / $ 0.54",
      vol24: 5.61,
    },
    {
      pair: {
        icon: AiOutlineStar,
        text: "SULLI / USDT",
      },
      lastPrice: "0.543218 / $ 0.54",
      vol24: 5.61,
    },
    {
      pair: {
        icon: AiOutlineStar,
        text: "SULLI / USDT",
      },
      lastPrice: "0.543218 / $ 0.54",
      vol24: 5.61,
    },
  ];

  const [pairs, setPairs] = useState([
    {
      name: "",
      symbolTwo: "",
      symbolOne: "",
      symbolOneID: "",
      symbolTwoID: "",
    },
  ]);

  const selectedOption = useSelector((state: any) => state.pair.selectedPair);
  const { themeValue } = useSelector((state: any) => state.spot);
  console.log("selected options", selectedOption);
  const dispatch = useDispatch();

  const handleOptionChange = (event: any) => {
    const selectedValue = event.target.value;
    const symbolPairTwo = selectedValue.split("/")[1];
    console.log("pair symbol two", symbolPairTwo);

    const symbolPairOne = selectedValue.split("/")[0];

    console.log("pair symbol one", symbolPairOne);
    const selectedObject = pairs.find(
      (option) => option.name === symbolPairOne + symbolPairTwo
    );
    // const { symbolOne, symbolTwo, name, symbolOneID, symbolTwoID }=selectedObject
    console.log("selected object", selectedObject);
    if (selectedObject) {
      dispatch(
        updatePair({
          selectedPair: selectedValue,
          pairName: selectedObject.name,
          pairOneSymbol: selectedObject.symbolOne,
          pairTwoSymbol: selectedObject.symbolTwo,
          symbolOneId: selectedObject.symbolOneID,
          symbolTwoId: selectedObject.symbolTwoID,
        })
      );
    }
  };
  const getAllpairs = async () => {
    const allPairs = await AXIOS.post("/getPairs", {
      api_key: api_key,
    });

    setPairs(allPairs.data.data);
    console.log("all apirs", allPairs.data.data);
    const {
      symbolOne,
      symbolTwo,
      name,
      symbolOneID,
      symbolTwoID,
    } = allPairs.data.data[0];
    console.log("response data", symbolOne, symbolTwo, name);
    dispatch(
      updatePair({
        selectedPair: symbolOne + "/" + symbolTwo,
        pairName: name,
        pairOneSymbol: symbolOne,
        pairTwoSymbol: symbolTwo,
        symbolOneId: symbolOneID,
        symbolTwoId: symbolTwoID,
      })
    );
  };
  useEffect(() => {
    getAllpairs();
  }, []);

  return (
    <div>
      <Container fluid className="m-lg-0 p-lg-0">
        <Row>
          {/* First column */}
          <Col lg={6} className="">
            {/* Sub row */}
            <Row className="spot_up spot_upper d-flex align-items-center py-3">
              {/* Sub columns */}
              <Col sm={5} xl={4}>
                <div className="spot_up_left d-flex align-items-center justify-content-start gap-3 gap-lg-4">
                  <div className="dropbox_dropdown">
                    <div className="d-flex align-items-center gap-1 spot_dropbox">
                      <img src={bitcoin} alt="BTC" />
                      <span>
                        {selectedOption}
                        </span>
                      <i>
                        <IoMdArrowDropdown className="dropbox_icon" />{" "}
                      </i>
                    </div>
                    <div className="spot_up_left_btn">
                      <div className="input-wrapper">
                        <FaSearch id="search-icon" />
                        <input
                          className="search_input"
                          type="text"
                          // onBlur={handleBlur}
                          // onFocus={handleFocus}
                          // value={input}
                          // onChange={(e) => handleChange(e.target.value)}
                          placeholder="Inquire"
                        />
                      </div>
                      <Form.Select
                        className=""
                        value={selectedOption}
                        onChange={handleOptionChange}
                      >
                        <option value="Select pair">Select pair</option>
                        {pairs.map((option, index) => (
                          <option
                            key={index}
                            value={option.symbolOne + "/" + option.symbolTwo}
                          >
                            {option.symbolOne + "/" + option.symbolTwo}
                          </option>
                        ))}
                      </Form.Select>
                      <div className="dropbox_content mt-3">
                        <Tab.Container
                          id="left-tabs-example"
                          defaultActiveKey="first"
                        >
                          <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                              <Nav.Link eventKey="star">
                                {" "}
                                <AiOutlineStar />{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="first">Zones</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="second">USDT</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="third">BTC</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="fourth">ETH</Nav.Link>
                            </Nav.Item>
                          </Nav>

                          <Tab.Content>
                            <Tab.Pane eventKey="star">
                              <Table borderless responsive>
                                <thead>
                                  <tr>
                                    <td>Pair</td>
                                    <td className="text-end">Last Price</td>
                                    <td className="text-end">24h Vol</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dropTable.map((item: any) => {
                                    {
                                      console.log("item", item);
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <AiOutlineStar /> {item.pair.text}
                                        </td>
                                        <td className="text-end">
                                          {item.lastPrice}
                                        </td>
                                        <td className="text-end">
                                          {item.vol24}M
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </Tab.Pane>
                            <Tab.Pane eventKey="first">
                              <Table borderless responsive>
                                <thead>
                                  <tr>
                                    <td>Pair</td>
                                    <td className="text-end">Last Price</td>
                                    <td className="text-end">24h Vol</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dropTable.map((item: any) => {
                                    {
                                      console.log("item", item);
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <AiOutlineStar /> {item.pair.text}
                                        </td>
                                        <td className="text-end">
                                          {item.lastPrice}
                                        </td>
                                        <td className="text-end">
                                          {item.vol24}M
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                              <Table borderless responsive>
                                <thead>
                                  <tr>
                                    <td>Pair</td>
                                    <td className="text-end">Last Price</td>
                                    <td className="text-end">24h Vol</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dropTable.map((item: any) => {
                                    {
                                      console.log("item", item);
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <AiOutlineStar /> {item.pair.text}
                                        </td>
                                        <td className="text-end">
                                          {item.lastPrice}
                                        </td>
                                        <td className="text-end">
                                          {item.vol24}M
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </Tab.Pane>
                            <Tab.Pane eventKey="third">
                              <Table borderless responsive>
                                <thead>
                                  <tr>
                                    <td>Pair</td>
                                    <td className="text-end">Last Price</td>
                                    <td className="text-end">24h Vol</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dropTable.map((item: any) => {
                                    {
                                      console.log("item", item);
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <AiOutlineStar /> {item.pair.text}
                                        </td>
                                        <td className="text-end">
                                          {item.lastPrice}
                                        </td>
                                        <td className="text-end">
                                          {item.vol24}M
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </Tab.Pane>
                            <Tab.Pane eventKey="fourth">
                              <Table borderless responsive>
                                <thead>
                                  <tr>
                                    <td>Pair</td>
                                    <td className="text-end">Last Price</td>
                                    <td className="text-end">24h Vol</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dropTable.map((item: any) => {
                                    {
                                      console.log("item", item);
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <AiOutlineStar /> {item.pair.text}
                                        </td>
                                        <td className="text-end">
                                          {item.lastPrice}
                                        </td>
                                        <td className="text-end">
                                          {item.vol24}M
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </div>
                    </div>
                  </div>
                  <div className="spot_up_left_content d-flex flex-column align-items-center ms-2">
                    <span>26058.3</span>
                    <small className="spot_up_left_content_small">
                      $ 26055.79
                    </small>
                  </div>
                </div>
              </Col>

              <Col sm={7} className="mt-1">
                <div className="spot_up_right d-flex ">
                  <Col
                    size={3}
                    className="spot_up_right_content d-flex flex-column align-items-start"
                  >
                    <p>24h Change</p>
                    <span className="spot_up_right_span1">-1.97</span>
                  </Col>
                  <Col
                    size={3}
                    className="spot_up_right_content d-flex flex-column align-items-start ms-lg-1"
                  >
                    <p>24h High</p>
                    <span>16,789.00</span>
                  </Col>
                  <Col
                    size={3}
                    className="spot_up_right_content d-flex flex-column align-items-start"
                  >
                    <p>24h Low</p>
                    <span>29,789.2</span>
                  </Col>
                  <Col
                    size={3}
                    className="spot_up_right_content d-flex flex-column align-items-start"
                  >
                    <p>24h VOL (BTC)</p>
                    <span>29,789.1</span>
                  </Col>
                </div>
              </Col>
            </Row>
            {/* Sub row 2 */}
            <Row>
              <Col className="p-lg-0 ps-lg-2">
                <div className="chart-height">
                  <TradingViewWidget
                    symbol="NASDAQ:AAPL"
                    locale="fr"
                    width="100%"
                    minHeight="auto"
                    theme={`${themeValue}`}
                  />
                </div>
              </Col>
            </Row>
          </Col>
          {/* Second Column */}
          <Col sm={6} lg={3} className="m-lg-0 p-lg-0">
            <TradeOrderBook />
          </Col>
          {/* Third Column */}
          <Col sm={6} lg={3} className="p-lg-0 m-lg-0">
            <OrderBook />
          </Col>
        </Row>
        {/* Second Row */}
        <Row>
          <Col lg={6}>
            <Tabss />
          </Col>
          <Col sm={6} lg={3}>
            <TradeTable />
          </Col>
          <Col sm={6} lg={3} className="p-0">
            <AssetTable />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
